import TagButton, { TAG_TARGET_PLAYER, TAG_TARGET_TEAM, TAG_TYPE_CUSTOM } from '@videotools/js/api/entities/TagButton';

// Tag group types
export const TYPE_DEFAULT = 'default';
export const TYPE_TRACKING = 'tracking';
export const TYPE_GRAPHICS = 'graphics';
export const TYPE_TIMING = 'timing';

// Visibility
export const VISIBILITY_PUBLIC = 'public';
export const VISIBILITY_CONTEXT = 'context';
export const VISIBILITY_PRIVATE = 'private';
export const ALL_VISIBILITIES = [
	VISIBILITY_PUBLIC,
	VISIBILITY_CONTEXT,
	VISIBILITY_PRIVATE,
];

// Sections
export const SECTION_DEFAULT = 'default';
export const SECTION_ADDITIONAL = 'additional';
export const SECTION_MARKING_EVENT = 'marking_event';
export const SECTION_MARKING_ATHLETE = 'marking_athlete';
export const SECTION_RUN = 'run';
export const SECTION_COMPETITION = 'competition';
export const SECTION_SCOREBOARD = 'scoreboard';
export const SECTION_CUSTOM_EVENT = 'custom_event';
export const SECTION_CUSTOM_PARTICIPANT = 'custom_participant';

const properties = [
	'id',
	'name',
	'visibility',
	'type',
	'tagButtons',
	'sections',
	'availableSections',
	'permission',
	'broadcastChannel',
];

/**
 * @property id
 * @property name
 * @property visibility
 * @property type
 * @property tagButtons {TagButton[]}
 * @property sections {Array} array of enabled sections
 */
export default class TagGroup {
	constructor(props) {
		for (const key of properties) {
			if (key in props) {
				if (key === 'tagButtons') {
					this.setTagButtons(props[key]);
				} else {
					this[key] = props[key];
				}
			}
		}
	}

	setTagButtons(buttons) {
		this.tagButtons = buttons?.map(data => new TagButton(data));
	}

	get isDefault() {
		return this.type === TYPE_DEFAULT;
	}

	get isSystemDefault() {
		return this.type === TYPE_DEFAULT && this.visibility === VISIBILITY_PUBLIC;
	}

	get isPublic() {
		return this.visibility === VISIBILITY_PUBLIC;
	}

	get isPrivate() {
		return this.visibility === VISIBILITY_PRIVATE;
	}

	get isContext() {
		return this.visibility === VISIBILITY_CONTEXT;
	}

	get defaultButtons() {
		return this.getSectionButtons(SECTION_DEFAULT).filter(btn => btn.target === TAG_TARGET_TEAM || btn.target === TAG_TARGET_PLAYER);
	}

	get additionalButtons() {
		return this.getSectionButtons(SECTION_ADDITIONAL);
	}

	get additionalParticipantButtons() {
		return this.additionalButtons.filter(btn => btn.target === TAG_TARGET_TEAM || btn.target === TAG_TARGET_PLAYER);
	}

	get customButtons() {
		return this.tagButtons.filter(tb => tb.type === TAG_TYPE_CUSTOM);
	}

	get customParticipantButtons() {
		return this.customButtons.filter(btn => btn.section === SECTION_CUSTOM_PARTICIPANT);
	}

	get customEventButtons() {
		return this.customButtons.filter(btn => btn.section === SECTION_CUSTOM_EVENT);
	}

	getSectionButtons(section) {
		return this.tagButtons.filter(tb => tb.section === section);
	}
}
